export enum RecordStatus {
  NoChange = "NO_CHANGE",
  Inserted = "INSERTED",
  Updated = "UPDATED",
  Deleted = "DELETED",
}
